import _ from 'lodash'

class Lodash {
    install (Vue) {
        Vue.prototype.$_ = _
        Vue.prototype._ = _
    }
}

export default new Lodash()
